var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Ver Detalle " + _vm.tituloDocumento },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("ImprimirButton", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imprimir.visible,
                expression: "imprimir.visible"
              }
            ],
            on: {
              click: function($event) {
                return _vm.imprimirDetalle("printDiv")
              }
            }
          })
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.informacionGeneral.visible,
                      expression: "informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [
                    _vm._v("Detalle " + _vm._s(_vm.tituloDocumento))
                  ]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.informacionGeneral.visible,
              expression: "informacionGeneral.visible"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center", id: "printDiv" }
        },
        [
          _c("br"),
          _c("FacturaForm", {
            attrs: {
              facturaSeleccionada: _vm.facturaSeleccionada,
              tipoDocumento: _vm.facturaSeleccionada.tipoDocumento
            }
          }),
          _c("FacturaTable", {
            attrs: {
              facturaSeleccionada: _vm.facturaSeleccionada.lDetalleDocumento
            }
          }),
          _c("FacturaResumen", {
            attrs: { facturaSeleccionada: _vm.facturaSeleccionada }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }